(function () {
  'use strict';
  const submissions = new WeakMap();
  const statuses = new WeakMap();
  const timers = new WeakMap();
  const activeForms = new Set();

  function showStatus(form, message = 'Pretražujem…', state = 'loading') {
    const parent = document.body || form;
    if (typeof document.createElement !== 'function' || typeof parent.appendChild !== 'function') return;
    let status = statuses.get(form);
    if (!status) {
      status = document.createElement('p');
      status.className = 'body3 search-submit-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      parent.appendChild(status);
      statuses.set(form, status);
    }
    status.setAttribute('data-state', state);
    status.textContent = message;
  }

  function clearStatus(form) {
    if (timers.has(form)) window.clearTimeout(timers.get(form));
    timers.delete(form);
    statuses.get(form)?.remove();
    statuses.delete(form);
    activeForms.delete(form);
  }

  function cancel(form) {
    submissions.set(form, (submissions.get(form) || 0) + 1);
    form.removeAttribute('aria-busy');
    clearStatus(form);
  }

  async function submit(form, searchConfig, completionTexts = []) {
    const input = form.querySelector('input[name="q"]');
    if (!input || !searchConfig.query) return;
    for (const previous of activeForms) if (previous !== form) cancel(previous);
    clearStatus(form);
    activeForms.add(form);
    const inputValue = input.value;
    const submissionId = (submissions.get(form) || 0) + 1;
    submissions.set(form, submissionId);
    form.setAttribute('aria-busy', 'true');
    showStatus(form);
    let navigating = false;
    try {
      const query = await window.WokieeSearchQuery.resolveQuery(
        searchConfig.query, searchConfig.unavailableMode, completionTexts, { waitForSuggestions: false }
      );
      if (submissions.get(form) !== submissionId || input.value !== inputValue || !form.isConnected) return;
      const url = new URL(form.action || window.routes?.search_url || '/search', window.location.origin);
      const params = new URLSearchParams(new FormData(form));
      params.set('q', query);
      params.set('type', 'product');
      params.set('options[prefix]', 'none');
      window.WokieeSearchQuery.applyStockParams(params, searchConfig);
      params.delete('page');
      url.search = params.toString();
      window.location.assign(url.toString());
      navigating = true;
      // Keep feedback during the document request; assign() returns before
      // Shopify sends the results. This timer never delays the navigation.
      if (statuses.has(form) && typeof window.setTimeout === 'function') timers.set(form, window.setTimeout(() => {
        if (submissions.get(form) !== submissionId) return;
        timers.delete(form);
        form.removeAttribute('aria-busy');
        showStatus(form, 'Otvaranje rezultata traje duže. Pokušajte ponovo.', 'slow');
      }, 15000));
    } catch (error) {
      if (submissions.get(form) === submissionId) {
        form.removeAttribute('aria-busy');
        showStatus(form, 'Pretraga nije uspela. Pokušajte ponovo.', 'error');
        navigating = true; // Preserve the useful error message until editing/retry.
      }
    } finally {
      if (!navigating && submissions.get(form) === submissionId) {
        form.removeAttribute('aria-busy');
        clearStatus(form);
      }
    }
  }

  function restoreResultInput() {
    const input = document.querySelector('[data-search-results-input]');
    if (!input) return;
    const query = window.WokieeSearchQuery.parseInput(input.value).query;
    const config = window.WokieeSearchQuery.stockConfigFromParams(new URLSearchParams(window.location.search));
    input.value = config.stockMode === 'soldout' ? `%${query}%` :
      config.stockMode === 'all' ? `%${query}` : query;
  }

  document.addEventListener('DOMContentLoaded', restoreResultInput);
  const resetNavigation = () => { for (const form of activeForms) cancel(form); };
  // Clear before a back/forward-cache snapshot and again after restoration.
  window.addEventListener?.('pagehide', resetNavigation);
  window.addEventListener?.('pageshow', (event) => { if (event.persisted) resetNavigation(); });
  window.WokieeSearchSubmit = Object.freeze({ submit, cancel, restoreResultInput });
})();
